export default "__VITE_ASSET__ac26e591__"